import { useCallback, useEffect, useState } from 'react';

import Icon, { IconType } from '@/components/icons';
import { getArticlesByCategory } from '@/helpers/BuilderHelper';
import { Locale, localifyLink, useLocale } from '@/helpers/LangHelper';
import { Article } from '@/types/Article';
import { Category } from '@/types/Category';
import B2BHeadliningArticlesBlock from '../b2b-headlining-articles-block/b2b-headlining-articles-block';
import { TYPE_OF_CARD } from '../b2b-headlining-articles-block/b2b-headlining-articles-block.constants';

import styles from './b2b-series-collection-articles-block.module.scss';

export interface B2BSeriesCollectionArticlesProps {
    titleSeries: string;
    descriptionSeries: string;
    viewAllText: string;
    category: string;
    viewAllUrl: string;

    categoryObject: Category;
    articles: Article[];

    typeOfCard?: TYPE_OF_CARD | undefined;
    includeLargeCard?: boolean;
    backgroundColor?: 'white' | 'gray-2' | 'gray-1';
    cardBackgroundColor?: 'white' | 'gray-2' | 'gray-1';
}

const B2BSeriesCollectionArticles = (props: B2BSeriesCollectionArticlesProps) => {
    const {
        titleSeries,
        descriptionSeries,
        viewAllUrl,
        viewAllText,
        typeOfCard,
        includeLargeCard,
        articles: articlesProps,
        category,
        categoryObject,
        backgroundColor = '',
        cardBackgroundColor = '',
    } = props;

    const { locale } = useLocale();
    const [articles, setArticles] = useState<Article[]>(articlesProps);

    const getArticles = useCallback(async () => {
        if (category && !articlesProps) {
            setTimeout(async () => {
                const articles = await getArticlesByCategory({ locale: Locale.USA, categoryIds: [category] });

                setArticles(articles);
            }, 500);
        }
    }, [articlesProps, category]);

    useEffect(() => {
        getArticles();
    }, [getArticles]);

    let getViewAllUrl = localifyLink(`/${locale}${viewAllUrl}`, locale);

    const viewAllTexts = (viewAllText: string) => (
        <>
            <span>{viewAllText}</span>
            <Icon type={IconType.ArrowRightMedium} />
        </>
    );

    return (
        <div className={styles.seriesCollectionBlock}>
            {backgroundColor ? <div className={styles[`seriesCollectionBlock${backgroundColor.replace(' ', '')}`]}></div> : null}
            <div className={styles.seriesHeader}>
                <div className={styles.infoSeries}>
                    <p className={styles.title}>{titleSeries}</p>
                    <p className={styles.description}>{descriptionSeries}</p>
                </div>
                {viewAllUrl === undefined ? (
                    <span className={styles.btnViewAll}>{viewAllTexts(viewAllText)}</span>
                ) : (
                    <a href={getViewAllUrl} className={styles.btnViewAll}>
                        {viewAllTexts(viewAllText)}
                    </a>
                )}
            </div>
            <B2BHeadliningArticlesBlock
                cardBackgroundColor={cardBackgroundColor}
                cardData={articles}
                typeOfCard={typeOfCard}
                showSignupCard={false}
                includeLargeCard={includeLargeCard}
                debounce={true}
            />
        </div>
    );
};

export default B2BSeriesCollectionArticles;
